module.exports = __webpack_public_path__ + "static/images/8c186c8b48ba2b59d18801c867189899.svg";